import { Image } from '@vivaldis/antd-ui'
import { useTranslation } from 'react-i18next'
import { EmployeeProfileQuery_employee } from '../../../../typings/EmployeeProfileQuery'
import { Information } from '../../../../../Information'
import { NotSetValue } from '../../../NotSetValue'
import { NotSetImageValue } from '../../../NotSetImageValue'

interface Props {
  employee: EmployeeProfileQuery_employee
}

export const WorkPermit = ({ employee }: Props) => {
  const [t] = useTranslation('web_ui')

  const { profile, workProfile } = employee

  // is true when null or undefined to show a short form (only id card fields)
  const eeaMember = profile?.nationalityCountry?.eeaMember ?? true

  // workPermit
  const workPermitBackPicture = workProfile?.workPermitBackPicture
  const workPermitFrontPicture = workProfile?.workPermitFrontPicture
  const workPermitExpiresOn = workProfile?.workPermitExpiresOn

  if (eeaMember) {
    return null
  }

  if (
    !workPermitBackPicture &&
    !workPermitFrontPicture &&
    !workPermitExpiresOn
  ) {
    return null
  }

  return (
    <>
      <Information.InformationSectionHeader>
        {t('employee_profile.work_permit_header')}
      </Information.InformationSectionHeader>
      {workPermitFrontPicture || workPermitBackPicture ? (
        <Information.InformationFieldWithTwoImages
          leftLabel={t('employee_profile.work_permit_front_picture')}
          rightLabel={t('employee_profile.work_permit_back_picture')}
          leftContent={
            <>
              {workPermitFrontPicture ? (
                <Image
                  width={238}
                  height={160}
                  src={String(workPermitFrontPicture)}
                />
              ) : (
                <div>
                  <NotSetImageValue />
                </div>
              )}
            </>
          }
          rightContent={
            <>
              {workPermitBackPicture ? (
                <Image
                  width={238}
                  height={160}
                  src={String(workPermitBackPicture)}
                />
              ) : (
                <div>
                  <NotSetImageValue />
                </div>
              )}
            </>
          }
        />
      ) : null}
      <Information.InformationField
        label={t('employee_profile.work_permit_expires_on')}
      >
        {workPermitExpiresOn ?? <NotSetValue />}
      </Information.InformationField>
    </>
  )
}
